export default __webpack_public_path__ + "static/media/noodles.08e7e0c7.jpeg";